import { POST_KEY } from '../../index'
import POST_TYPE_TO_DOMAIN_LIST_PATH from '../../../../../modules/posts/constants/type-to-domain-list-path'
import { getValueReduxUtil } from '../../../../../modules/redux/utils/get-value'

function getDomainListPathPostUtil (instance) {
  const type = getValueReduxUtil(instance, POST_KEY.TYPE)
  return POST_TYPE_TO_DOMAIN_LIST_PATH[type]
}

export default getDomainListPathPostUtil
